import { Component } from "react";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import Nav from "@/components/anichya/Nav";
import Hero from "@/components/anichya/Hero";
import Idea from "@/components/anichya/Idea";
import CoffeeStory from "@/components/anichya/CoffeeStory";
import InstagramJournal from "@/components/anichya/InstagramJournal";
import About from "@/components/anichya/About";
import FirstRelease from "@/components/anichya/FirstRelease";
import Footer from "@/components/anichya/Footer";
import WhatsAppButton from "@/components/anichya/WhatsAppButton";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ padding: "45vh 24px 0", textAlign: "center", fontFamily: "Georgia, serif" }}>
          Something gave way. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

const Home = () => {
  useLenis();
  return (
    <div className="grain bg-paper text-ink antialiased">
      <Nav />
      <main>
        <Hero />
        <Idea />
        <CoffeeStory />
        <InstagramJournal />
        <About />
        <FirstRelease />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="bottom-center" />
    </div>
  );
};

export default function App() {
  return (
    <ErrorBoundary>
      <Home />
    </ErrorBoundary>
  );
}
